import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PhasesOfContrast, ScanRegionForm } from '../../model';

@Component({
    /* eslint-disable-next-line @angular-eslint/component-selector */
    selector: '[app-scan-region]',
    templateUrl: './scan-region.component.html',
    styleUrl: './scan-region.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ScanRegionComponent implements OnInit, OnDestroy {
    phasesOfContrast = PhasesOfContrast;

    @Input()
    scanRegionFields: FormGroup<ScanRegionForm>;

    @Input()
    modalities: string[];

    @Input()
    bodyParts: string[];

    @Input()
    index: number;

    @Output()
    scanRegionChange = new EventEmitter<void>();

    @Output()
    deleteScanRegion = new EventEmitter<number>();

    private readonly _subscriptions = new Subscription();

    ngOnInit() {
        if (this.scanRegionFields) {
            this._subscriptions.add(
                this.scanRegionFields.valueChanges.subscribe(_values => {
                    this.scanRegionChange.emit();
                })
            );
        }
    }

    get modality() {
        return this.scanRegionFields.controls.modality;
    }

    get bodyPart() {
        return this.scanRegionFields.controls.bodyPart;
    }

    get phaseOfContrast() {
        return this.scanRegionFields.controls.phaseOfContrast;
    }

    delete() {
        this.deleteScanRegion.emit(this.index);
    }

    ngOnDestroy() {
        this._subscriptions.unsubscribe();
    }
}
